import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryWrapper } from 'app/types';
import { useSnakeBar } from '../../useSnakeBar';
import type { UsageInvoicingOwner } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const queryFn = async () => {
  const response = await adminServices.getUsageInvoicingOwners();
  return response.data;
};

const QUERY_KEY = 'getUsageInvoicingOwners';

export const useUsageInvoicingOwnersQuery: UseQueryWrapper<UsageInvoicingOwner[], undefined, false> = ({
  options,
} = {}) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<UsageInvoicingOwner[]>([QUERY_KEY], queryFn, {
    onError,
    ...(options || {}),
  });
};
